import { apiClient } from '../utils/apiClient';

const userService = {
  getUserDetails: async () => {
    try {
      const response = await apiClient.user.getProfile();

      return response?.data?.data;
    } catch (error) {
      console.error('=== Data Flow Error ===', error);
      throw error;
    }
  }
};

export default userService;
